import { PDF_COLORS } from "./stylesPDFv2";

/**
 * Miniatura(s) de imagen del insumo, para colocarse DENTRO de la celda de
 * Descripción (debajo del texto), de modo que quede claramente asociada a su
 * partida. Devuelve null si no hay imágenes.
 *
 * @param {Array<string>} imagenes data URLs (base64) ya validadas
 * @returns nodo pdfMake | null
 */
export const PDFItemImagesV2 = (imagenes = []) => {
  const imgs = (imagenes || []).filter(Boolean);
  if (!imgs.length) return null;
  return {
    margin: [0, 4, 0, 1],
    stack: imgs.map((img) => ({ image: img, fit: [96, 80], margin: [0, 0, 0, 4] })),
  };
};

/**
 * Tabla de conceptos (partidas) con estilo moderno.
 *
 * @param {object} params
 * @param {Array} params.title     fila de encabezado (celdas pdfMake)
 * @param {Array} params.conceptos filas de partidas (arrays de celdas)
 * @param {Array<string>} params.widths anchos de columnas
 * @returns nodo pdfMake (table)
 */
export const PDFItemsTableV2 = ({ title, conceptos = [], widths } = {}) => ({
  style: "tableExample",
  table: {
    headerRows: 1,
    widths,
    body: [title, ...conceptos],
  },
  layout: {
  fillColor: () => null,

  hLineWidth: (i, node) => {
    const totalRows = node.table.body.length;
    if (i === 0) return 0;
    if (i === 1) return 1.5;            // bajo el header (fuerte)
    if (i === totalRows) return 0;      // pie de la tabla (quitado)
    return 0.5;                          // entre insumos
  },
  hLineColor: () => PDF_COLORS.tableDivider,
  vLineWidth: () => 0,
  paddingTop: () => 4,
  paddingBottom: () => 4,
  paddingLeft: () => 4,
  paddingRight: () => 4,
},
});

export default PDFItemsTableV2;